// 记录/恢复 各用户最后打开的一级模块与固定二级Tab
// Storage 结构（按用户隔离）：
// {
//   modulePath: "/homePage/productionOrder",   // 最后打开的一级模块
//   tab: "first",                             // 该模块内最后激活的固定顶级Tab
//   subTabs: {                                 // 按模块命名空间的固定二级Tab状态
//     "/homePage/productionOrder": { cutView: false },
//     "/homePage/deviceManage": { cutView: true }
//   }
// }
import { getLocalStorage, setLocalStorage, removeLocalStorage, getSessionStorage } from "@/utils/myStorage.js";

const KEY_PREFIX = "lastModule_";
const KEY_DEFAULT = "lastModule_default";

// 当前登录用户ID
function currentUserId() {
  try {
    const info = getLocalStorage("userInfo") || getSessionStorage("userInfo") || {};
    return info.id ? String(info.id) : "";
  } catch (e) {
    return "";
  }
}

function key() {
  const uid = currentUserId();
  return uid ? KEY_PREFIX + uid : KEY_DEFAULT;
}

// 读取整个记录
export function getLastModule() {
  try {
    return getLocalStorage(key()) || {};
  } catch (e) {
    return {};
  }
}

// 保存整个记录
export function setLastModule(data) {
  setLocalStorage(key(), data);
}

// 记录最后打开的一级模块路径
export function setLastModulePath(path) {
  const d = getLastModule() || {};
  d.modulePath = path;
  setLastModule(d);
}

// 读取最后打开的一级模块路径
export function getLastModulePath() {
  const d = getLastModule() || {};
  return d.modulePath || "";
}

// 复位：仅当当前存储中还没有该用户的记忆或记忆为空时写入初值
export function ensureLastModule(init) {
  const d = getLastModule();
  if (!d.modulePath) {
    setLocalStorage(key(), Object.assign({}, init));
    return Object.assign({}, init);
  }
  return d;
}

// 清空当前用户记录（退出登录时调用）
export function clearLastModule() {
  removeLocalStorage(key());
  removeLocalStorage("lastModule_default");
}

export default {
  getLastModule,
  setLastModule,
  ensureLastModule,
  clearLastModule,
  currentUserId,
};
